import styled from '@emotion/styled';
import { BoxProps } from '@mui/material';
import { shouldForwardProps } from '../../utils';
import { Breakpoint } from '../../types';
import { Column } from '../../styles';

interface FaqScreenGridProps extends BoxProps {
    breakpoint: Breakpoint;
}

const FaqScreenGrid = styled(Column, shouldForwardProps)<FaqScreenGridProps>`
    width: 100%;
    gap: ${({ theme }) => theme.spacing(3)};
    align-items: start;
`;

export { FaqScreenGrid };
